import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Drawer from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { skipToken } from "@reduxjs/toolkit/query";

import { CloseButton } from "@covertree/ui";

import { useGetCommunitiesForExistingPortfolioQuery } from "@redux/portfolios/portfoliosApi";
import { BASE_PORTFOLIOS_PATH } from "@routing/Portfolios";
import { PortfolioDetailsContent } from "@routing/Portfolios/PortfolioDetails/PortfolioDetailsContent";

export function PortfolioDetails() {
  const { portfolioId } = useParams<{ portfolioId: string }>();

  const navigate = useNavigate();

  if (!portfolioId) {
    navigate(`/${BASE_PORTFOLIOS_PATH}`);
    return;
  }

  const {
    currentData: communities,
    isError,
    isFetching,
  } = useGetCommunitiesForExistingPortfolioQuery(
    portfolioId ? { id: portfolioId } : skipToken,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const onClose = useCallback(() => {
    navigate({
      pathname: "../",
    });
  }, []);

  return (
    <Drawer
      anchor="right"
      open={!!portfolioId}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: {
            xs: "50%",
          },
          maxWidth: { xl: "870px" },
        },
      }}>
      <Stack direction="column" p={3} height="100%">
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h3">Portfolio Details</Typography>
          <CloseButton onClick={onClose} />
        </Stack>
        <PortfolioDetailsContent
          isError={isError}
          isLoading={isFetching || !portfolioId}
          communities={communities}
        />
      </Stack>
    </Drawer>
  );
}
